import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './CounterpartiesTabTableHead.scss';

export const COUNTERPARTIES_TAB_TABLE_HEADER = [
  {
    label: 'counterpartyNumber'
  },
  {
    label: 'direction'
  },
  {
    label: 'counterpartyName'
  },
  {
    label: 'accountNumberSortCodeBic'
  },
  {
    label: 'totalTransactionsAmount',
    sortBy: 'totalTransactionsAmount'
  },
  {
    label: 'currencyDefault'
  },
  {
    label: 'totalTransactionsCount',
    sortBy: 'totalTransactionsCount'
  },
  {
    label: 'transactionNumbers'
  },
  {
    label: 'documents'
  }
];

const CounterpartiesTabTableHead = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {COUNTERPARTIES_TAB_TABLE_HEADER.map(
        (head) =>
          head.label && (
            <th key={head.label} className={'counterparties-tab-table-head'}>
              <div className={'counterparties-tab-table-head-block'}>
                <span>{i18n.getMessage(`counterparties.tab.table.header.${head.label}`)}</span>
                {head.sortBy && (
                  <ArrowSelect
                    onClick={() => handleOnSortTable(head.sortBy)}
                    className={`counterparties-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
                  />
                )}
              </div>
            </th>
          )
      )}
    </tr>
  );
};

CounterpartiesTabTableHead.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};

export default CounterpartiesTabTableHead;
